export default __webpack_public_path__ + "static/media/bg-texture-green.d151c851.jpg";